import { Chip, Tooltip, Typography } from "@mui/material"
import { If, Else } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"
import { formatLargeNumber } from "../format-utils"
import { formatContractDaysExact, formatContractDaysLabel } from "./format-contract-days"

export function FixedContractCapacityCell({ assessment, currencySymbol }) {
    return (
        <If value={!!assessment}>
            <If value={assessment?.overCapacity}>
                <Tooltip title={getShortfallTooltip()} placement="top">
                    <Chip
                        size="small"
                        variant="outlined"
                        color="error"
                        icon={<Iconify icon="mdi:alert-outline" />}
                        label={getShortfallLabel()}
                        data-cy="fixed-contract-shortfall"
                    />
                </Tooltip>
                <Else>
                    <Typography variant="body2" color="text.secondary" data-cy="fixed-contract-headroom">
                        {formatContractDaysLabel(assessment?.headroomDays)} headroom
                    </Typography>
                </Else>
            </If>
            <Else>
                <Typography variant="body2" color="text.secondary">
                    —
                </Typography>
            </Else>
        </If>
    )

    function getShortfallLabel() {
        return `${formatContractDaysLabel(assessment?.shortfallDays)} over · ${formatLargeNumber(
            assessment?.additionalCost,
            currencySymbol
        )} more`
    }

    function getShortfallTooltip() {
        const amount = formatLargeNumber(assessment?.amount, currencySymbol)
        const extra = formatLargeNumber(assessment?.additionalCost, currencySymbol)
        return `${amount} buys ${formatContractDaysExact(assessment?.contractedDays)} days, this scenario needs ${formatContractDaysExact(
            assessment?.requiredDays
        )} days, that's roughly ${extra} more at contract rate, before modifiers.`
    }
}
